export enum OpportunitiesTabEnum {
  BrandInvites = 'brandInvites',
  Recommended = 'recommended',
  Negotiating = 'negotiating',
  Paused = 'paused'
}

export const getOpportunitiesTabItems = (
  t: any,
  badges: Record<OpportunitiesTabEnum, number>
) => {
  return [
    {
      key: OpportunitiesTabEnum.BrandInvites,
      label: t('deals.opportunities.tab_brand_invites', {
        defaultValue: 'Brand invites'
      }),
      badge: badges[OpportunitiesTabEnum.BrandInvites],
      value: OpportunitiesTabEnum.BrandInvites
    },
    {
      key: OpportunitiesTabEnum.Recommended,
      label: t('deals.opportunities.tab_recommended', {
        defaultValue: 'Recommended'
      }),
      badge: badges[OpportunitiesTabEnum.Recommended],
      value: OpportunitiesTabEnum.Recommended
    },
    {
      key: OpportunitiesTabEnum.Negotiating,
      label: t('deals.opportunities.tab_negotiating', {
        defaultValue: 'Negotiating'
      }),
      badge: badges[OpportunitiesTabEnum.Negotiating],
      value: OpportunitiesTabEnum.Negotiating
    },
    {
      key: OpportunitiesTabEnum.Paused,
      label: t('deals.opportunities.tab_paused', {
        defaultValue: 'Paused'
      }),
      value: OpportunitiesTabEnum.Paused
    }
  ];
};

const MS_PER_HOUR = 1000 * 60 * 60;
const MS_PER_DAY = MS_PER_HOUR * 24;

export const getTimeText = (time: string | Date, t: any) => {
  const pastMs = Math.max(0, Date.now() - new Date(time).getTime());

  if (pastMs <= MS_PER_DAY) {
    const hours = Math.max(1, Math.ceil(pastMs / MS_PER_HOUR));
    return t('deals.opportunities.time_hours_ago', {
      defaultValue: '{{countNum}}h ago',
      countNum: hours
    });
  }

  const days = Math.floor(pastMs / MS_PER_DAY);
  if (days === 1) {
    return t('deals.opportunities.time_one_day_ago', {
      defaultValue: '1 day ago'
    });
  }
  return t('deals.opportunities.time_days_ago', {
    defaultValue: '{{countNum}} days ago',
    countNum: days
  });
};
